import HttpService from 'domovio-core/src/system/rest/rest.service';

export async function loadInterests(projectId) {
    return HttpService.get('/v1/interests/', { projectId });
}

export async function removeInterest(interestId) {
    return HttpService.delete('/v1/interests/' + interestId).then(() => interestId);
}
